module.exports = __webpack_public_path__ + "assets1733911544048/img/lan5.01bd8a8d.png";